module.exports = __webpack_public_path__ + "static/media/logo-4 1.0fe130b1.png";